// Entry point: global styles, the app instance and the root component.
// base.css must stay the first import so component styles (imported below) override it.
import './ui/styles/base.css';
import { render } from 'preact';
import { App } from './app/App';
import { AppContext } from './app/context';
import { createApp } from './app/createApp';

const root = document.getElementById('app');
if (!root) throw new Error('index.html must contain <div id="app">');

const app = createApp();
render(
  <AppContext.Provider value={app}>
    <App />
  </AppContext.Provider>,
  root,
);
app.start();
